/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {EndChatRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {EndChatResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const endChat = (request:EndChatRequest, options?: CashRequestOptions) => post<EndChatRequest, EndChatResponse>("/2.0/cash/end-chat", request, {...options, rejectOnError: true })